<template>
  <div class="sso-login-button">
    <DpplNewButton
      class="sso-button w-100 text-button-2"
      variant="outlined"
      :height="40"
      :active="isActive"
      :title="ssoButtonText"
      @click="onSsoClick"
    >
      Sign in with&nbsp; <span class="company-name">{{ ssoButtonText }}</span>
    </DpplNewButton>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { redirectToSsoProvider } from '@/helpers/redirect';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';

const router = useRouter();

const props = defineProps({
  isActive: { type: Boolean, default: false },
  ssoProvider: { type: String, default: '' },
  ssoName: { type: String, default: '' },
  isGoogle: { type: Boolean, default: false },
  isMicrosoft: { type: Boolean, default: false },
});

const emit = defineEmits(['toggleSso']);

const ssoButtonText = computed(() => {
  if (props.ssoProvider) return props.ssoProvider.replaceAll('_', ' ');
  if (props.ssoName) return props.ssoName.replaceAll('_', ' ');
  return 'SSO';
});

const onSsoClick = () => {
  if (props.ssoName) {
    const { from = '' } = router.currentRoute.value.query || {};
    redirectToSsoProvider({
      from,
      provider: props.ssoName,
      isGoogle: props.isGoogle,
      isMicrosoft: props.isMicrosoft,
    });
    return;
  }

  emit('toggleSso');
};
</script>

<style scoped lang="less">
.sso-button:deep(.v-btn__content) {
  overflow: hidden;

  .company-name {
    text-transform: capitalize;
  }
}
</style>
